import { useCallback, useEffect } from "react"

import {
    Layer as ReactMapLayer,
    useMap,
} from "react-map-gl"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { BASE_MAP_ID } from "../../constants/map"
import { useMapDispatchContext } from "../../contexts/MapContext"

export const Layer = (props) => {
    const {
        id,
        interactive,
        mapId,
        onClick,
        onMouseEnter,
        onMouseLeave,
        ...layerProps
    } = props

    const { current: map } = useMap()
    const { addLayerClickListener, removeLayerClickListener } = useMapDispatchContext()

    const handleMouseEnter = useCallback((e) => {
        map.getCanvas().style.cursor = "pointer"
        if (onMouseEnter) {
            onMouseEnter(e)
        }
    }, [map, onMouseEnter])

    const handleMouseLeave = useCallback(() => {
        map.getCanvas().style.cursor = ""
        if (onMouseLeave) {
            onMouseLeave()
        }
    }, [map, onMouseLeave])

    useEffect(() => {
        if (!map || !onClick || !interactive) {
            return
        }
        addLayerClickListener(id, onClick, mapId)
        map.on("mouseenter", id, handleMouseEnter)
        map.on("mouseleave", id, handleMouseLeave)

        return function cleanup() {
            removeLayerClickListener(id)
            map.off("mouseenter", id, handleMouseEnter)
            map.off("mouseleave", id, handleMouseLeave)
        }
    }, [handleMouseEnter,
        handleMouseLeave,
        map,
        mapId,
        id,
        interactive,
        onClick,
        onMouseEnter,
        onMouseLeave,
        addLayerClickListener,
        removeLayerClickListener])

    return <ReactMapLayer id={id} {...layerProps} />
}

Layer.propTypes = {
    ...ReactMapLayer.propTypes,
    id: PropTypes.string.isRequired,
    interactive: PropTypes.bool,
    mapId: PropTypes.string,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
}

Layer.defaultProps = {
    interactive: true,
    mapId: BASE_MAP_ID,
}